<template>
	<li class="settings-list-row">
		<div class="settings-list-header min-h-9">
			<span class="settings-list-row-name">{{ name }}</span>
			<slot />
		</div>
		<div v-if="slots['below-header']" class="below-header">
			<slot name="below-header" />
		</div>
	</li>
</template>

<script lang="ts" setup>
import { useSlots } from "vue";

defineProps<{
	name: string;
}>();

const slots = useSlots();
</script>

<style lang="scss">
.settings-list-row {
	display: flex;
	flex-direction: column;
	padding: 8px 0;
	gap: 4px;

	&:not(:last-child) {
		border-bottom: 1px solid var(--border);
	}

	.settings-list-header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.settings-list-row-name {
		font-weight: 500;
	}

	&.danger {
		.settings-list-row-name {
			color: var(--text-danger);
		}
	}
}
</style>
